import { AxiosResponse } from 'axios';

import { SFCCBasket } from '../../../models/sfcc-basket';
import { SFCCProductItem } from '../../../models/sfcc-product-item';
import { makeCurrentBasketAction } from '../../../utilities/make-current-basket-action';
import { shopHttp } from '../../basket-api';

export const setQuantity = async (
  itemId: string,
  sku: string,
  quantity: number,
  ensureBasketMethod: () => Promise<SFCCBasket>
): Promise<SFCCBasket> => {
  const body: SFCCProductItem = { product_id: sku, quantity };

  return await makeCurrentBasketAction(
    `items/${itemId}`,
    setQuantityToProduct,
    ensureBasketMethod,
    body
  );
};

const setQuantityToProduct = async (
  requestPath: string,
  body: SFCCProductItem
): Promise<SFCCBasket> => {
  const response = await shopHttp.patch<SFCCProductItem, AxiosResponse<SFCCBasket>>(
    requestPath,
    body
  );

  return response.data;
};
